import { render, staticRenderFns } from "./BeziehungReiter.vue?vue&type=template&id=0996f5e0"
import script from "./BeziehungReiter.vue?vue&type=script&lang=js"
export * from "./BeziehungReiter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports